module.exports = __webpack_public_path__ + "static/img/TD.219cac3e.png";